<template>
  <div class="cookies-modal" :class="{'d-none': !show }">
    <div class="h-100 position-relative">
      <div ref="cookiesModalRef" class="w-100 bg-black cookies-modal-container position-absolute py-4">
        <div class="container-sm">
          <div class="row">
            <div class="col-12 col-lg-9 d-flex align-items-center">
              <div>
                <div class="text-white" style="display: contents" v-html="explanation">
                </div>
                <Link :href="readMoreLink" class="text-secondary">{{readMoreText}}</Link>
              </div>
            </div>
            <div class="col-12 col-lg-3 d-flex flex-column align-items-center">
              <button class="btn-nulled text-uppercase fw-bold cookies-accept-btn" @click="handleAccept">{{acceptButton}}</button>
              <button class="btn-nulled text-secondary mt-2" @click="handleReject"><p>{{rejectButton}}</p></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Link from "@/components/common/Link";
export default {
  components: {Link},
  data(){
    return {
      show: true
    }
  },
  mounted() {
    const userCookies = localStorage.getItem('cookies')
    if(userCookies === 'all' || userCookies === 'reject') {
      this.show = false
    }
  },
  props: {
    explanation: String,
    acceptButton: String,
    rejectButton: String,
    readMoreLink: String,
    readMoreText: String
  },
  methods: {
    handleAccept(){
      this.show = false;
      localStorage.setItem('cookies', 'all')
    },
    handleReject(){
      this.show = false;
      localStorage.setItem('cookies', 'reject')
    }
  },
}
</script>
